import { IconButton } from '@dixa/lib-shared-habla';
import classnames from 'classnames';

import styles from './mimSidekickLauncher.module.scss';

type MimSidekickLauncherProps = {
  hasUnread: boolean;
  autoFocus: boolean;
  onClick: () => void;
};

export const MimSidekickLauncher = ({
  hasUnread,
  autoFocus,
  onClick,
}: MimSidekickLauncherProps): JSX.Element => {
  return (
    <span className={classnames(styles.wrapper, 'print-hidden')}>
      <IconButton
        icon="mim-sidekick"
        variant="primary"
        onClick={onClick}
        autoFocus={autoFocus}
        iconSize={24}
        aria-label={
          hasUnread ? 'Open Mim Sidekick, new reply' : 'Open Mim Sidekick'
        }
        className={styles.launcher}
        size="large"
      />
      {hasUnread && <span className={styles.dot} aria-hidden="true" />}
    </span>
  );
};
